import { HowWordsCheck } from "../../functions/getStreak";
import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useProject } from "../../hooks/useProject";
import Flower from '../../components/common/Flower/Flower';
import ClickFlower from '../../components/common/ClickFlower/ClickFlower';
import { Link } from "react-router-dom";
import ProjectHeader from "../../components/common/ProjectHeader/ProjectHeader";
import { IoIosArrowBack } from "react-icons/io";

export default function ProjectCalculator(){
    const {index, project} = useProject();
    const [ResultWords, setResult] = useState();
    const navigate = useNavigate();
    return (
        <div className="projectlist-wrapper">
            <ProjectHeader
                headerTitle={"Kalkulator"}
                showBackButton={true}
                path={`/offline/project/${index}`}
            />
            <div className="SettingsForm" style={{marginTop: '100px'}}>
                <form onSubmit={(e) =>{
                e.preventDefault();
                const result = HowWordsCheck(e, project);
                setResult(result);
                }}> 
                <label>
                  Kiedy chcesz skończyć projekt
                  <input type = "date" name = "finishDate" className="chapterInput"/> 
                </label>
                 <br/>
                <div className="buttons-row">
                    <button> Ile słów muszę pisać? </button>
                </div>
                <h6>Musisz pisać: {ResultWords}</h6>
            </form>
                
            </div>

            <Link to={`/offline/project/${index}`} className="BackfixButton"><IoIosArrowBack /></Link>
            <Flower
            flowerClass={"flower1"}/>
            <Flower
            flowerClass={"flower2"}/>
            <ClickFlower/>

        </div>
    )
}
